import {
  CloneMentorshipProgramState,
  CloneMentorshipProgramAction,
  CloneMentorshipProgramActionType,
  CloneMentorshipProgramWizardStep,
} from './types';

export const initialState: CloneMentorshipProgramState = {
  sourceProgram: null,
  targetConfig: {
    name: '',
    releasedDate: null,
    description: '',
  },
  admins: [],
  selectedAdmins: {},
  isFetchingAdmins: false,
  step: CloneMentorshipProgramWizardStep.CONFIG,
  isCloning: false,
  errors: {},
  cloneProgress: undefined,
};

/* @ngInject */
export function cloneMentorshipProgramReducer(
  state: CloneMentorshipProgramState,
  action: CloneMentorshipProgramAction,
): CloneMentorshipProgramState {
  switch (action.type) {
    case CloneMentorshipProgramActionType.SET_SOURCE_PROGRAM:
      return {
        ...state,
        sourceProgram: action.payload,
        targetConfig: {
          ...state.targetConfig,
          name: action.payload.name, // defaults to the source's name
          description: action.payload.description ?? '', // defaults to the source's description
        },
        errors: {},
      };

    case CloneMentorshipProgramActionType.UPDATE_TARGET_CONFIG:
      return {
        ...state,
        targetConfig: {
          ...state.targetConfig,
          ...action.payload,
        },
      };

    case CloneMentorshipProgramActionType.TOGGLE_ADMIN:
      return {
        ...state,
        selectedAdmins: {
          ...state.selectedAdmins,
          [action.payload.adminId]: action.payload.selected,
        },
      };

    case CloneMentorshipProgramActionType.TOGGLE_ALL_ADMINS: {
      const next: Record<string, boolean> = {};
      state.admins.forEach((admin) => {
        next[String(admin.id)] = action.payload.selected;
      });
      return {
        ...state,
        selectedAdmins: next,
      };
    }

    case CloneMentorshipProgramActionType.SET_ADMINS: {
      // Default all newly loaded admins to selected unless we already have a value for them.
      const nextSelected: Record<string, boolean> = { ...state.selectedAdmins };
      action.payload.forEach((admin) => {
        const key = String(admin.id);
        if (nextSelected[key] === undefined) {
          nextSelected[key] = true;
        }
      });
      return {
        ...state,
        admins: action.payload,
        selectedAdmins: nextSelected,
      };
    }

    case CloneMentorshipProgramActionType.SET_FETCHING_ADMINS:
      return {
        ...state,
        isFetchingAdmins: action.payload,
      };

    case CloneMentorshipProgramActionType.SET_STEP:
      return {
        ...state,
        step: action.payload,
      };

    case CloneMentorshipProgramActionType.NEXT_STEP:
      return {
        ...state,
        step: Math.min(CloneMentorshipProgramWizardStep.REVIEW, state.step + 1),
      };

    case CloneMentorshipProgramActionType.PREV_STEP:
      return {
        ...state,
        step: Math.max(CloneMentorshipProgramWizardStep.CONFIG, state.step - 1),
      };

    case CloneMentorshipProgramActionType.SET_CLONING_STATUS:
      return {
        ...state,
        isCloning: action.payload,
      };

    case CloneMentorshipProgramActionType.SET_ERRORS:
      return {
        ...state,
        errors: action.payload,
      };

    case CloneMentorshipProgramActionType.RESET_WIZARD:
      return initialState;

    default:
      return state;
  }
}
